<template>
  <el-container class="data-detail-wrip">
    <header>
      <i class="iconfont icon-nav-platform"></i>
      <i class="iconfont icon-close" @click="closeDialog"></i>
      {{componentDetail.cm_name}}
    </header>
    <div class="tab-box">
      <div class="tab-item" :class="(tabType == 0)?'active':''"><span>基本资料</span></div>
    </div>
    <div class="head" v-if="tabType == 0">
      <span>基本资料</span>
      <el-dropdown trigger="click" @command="handleCommand" v-if="componentDetail.cm_default !== '1' && (funAuth.includes(57) || funAuth.includes(58)) && componentDetail.use_custom === 0">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon-more"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1" v-if="componentDetail.cm_state === '1' && funAuth.includes(58)">禁  用</el-dropdown-item>
          <el-dropdown-item command="1" v-if="componentDetail.cm_state === '0' && funAuth.includes(58)">启  用</el-dropdown-item>
          <el-dropdown-item command="2" v-if="componentDetail.cm_state === '0' && funAuth.includes(57)">删  除</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="editComponent" v-if="funAuth.includes(56)">编 辑</el-button>
    </div>
    <div class="head" v-if="tabType == 1">
      <span>操作记录</span>
    </div>
    <div class="content">
      <el-collapse v-model="activeNames" v-if="tabType == 0">
        <el-collapse-item name="1">
          <template slot="title">基本信息</template>
          <div class="form">
            <div class="item single">
              <span class="title">名称</span>
              <div class="item-content">{{componentDetail.cm_name}}</div>
            </div>
            <div class="item">
              <span class="title">状态</span>
              <div class="item-content">{{componentDetail.cm_state == 1 ? '启用' : '禁用'}}</div>
            </div>
            <div class="item">
              <span class="title">使用客户数</span>
              <div class="item-content">{{componentDetail.use_custom}}</div>
            </div>
            <div class="item single">
              <span class="title">备注</span>
              <div class="item-content">{{componentDetail.cm_describe}}</div>
            </div>
            <div class="item single">
              <feature-list :featureData="featureData"></feature-list>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">系统信息</template>
          <div class="form">
            <div class="item">
              <span class="title">创建人</span>
              <div class="item-content">{{componentDetail.create_by}}</div>
            </div>
            <div class="item">
              <span class="title">创建时间</span>
              <div class="item-content">{{componentDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
            <div class="item">
              <span class="title">修改人</span>
              <div class="item-content">{{componentDetail.modify_by}}</div>
            </div>
            <div class="item">
              <span class="title">修改时间</span>
              <div class="item-content">{{componentDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">只有停用状态的数据才允许删除。</div>
      <div class="prompt">定要删除该数据吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="delComponentManage">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">{{(componentDetail.cm_state == 1) ? '停用':'启用'}}</div>
      <div class="note">{{(componentDetail.cm_state == 1) ? '没有任何公司使用的时候才允许停用，如果有公司在使用该内容则不允许停用。':''}}</div>
      <div class="prompt">{{(componentDetail.cm_state == 1) ? '确定要停用该内容吗？':'确定要启用该内容吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="componentStatus">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <component-add v-if="dialogAdd" :component="componentDetail"></component-add>
    </transition>
  </el-container>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import {HTTPServer} from '@/common/js/ajax.js'
import featureList from '@/common/components/feature-list'// 功能清单
import componentAdd from '@/page/business/component-add'// 新增

export default {
  props: ['component'],
  mixins: [mixin],
  data () {
    return {
      componentDetail: {},
      activeNames: ['1', '2', '3', '4'],
      moduleId: 17,
      tabType: 0,
      dialogDelete: false,
      dialogAdd: false,
      dialogStatus: false
    }
  },
  components: {
    featureList,
    componentAdd
  },
  mounted () {
    this.getComponentManageDetail()
    console.log('组件详情', this.componentDetail)
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // if (this.componentDetail.type === 2) {
    //   this.querycomponentById()
    // } else if (this.componentDetail.type === 3) {
    //   // this.queryAllChargingStrategy()
    // }
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      console.log(value)
      if (value) {
        this.dialogAdd = false
      }
    })
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      console.log(value)
      if (value) {
        this.dialogAdd = false
      }
    })
    /** 更新详情 */
    this.$bus.off('query-component-detail')
    this.$bus.on('query-component-detail', (value) => {
      console.log(value)
      if (value) {
        this.getComponentManageDetail()
      }
    })
  },
  methods: {
    // 获取详情
    getComponentManageDetail () {
      HTTPServer.getComponentManageDetail({cmId: this.component.id}, 'Loading').then((res) => {
        this.componentDetail = res
        let arr = [{'funcList': res.basic_component, 'moduleName': '基础字段', 'type': 'basic_component'}, {'funcList': res.high_component, 'moduleName': '高级类组件', 'type': 'high_component'}]
        let componentAuth = {'basic_component': [], 'high_component': []}
        if (this.componentDetail.component_auth) {
          componentAuth.basic_component = this.componentDetail.component_auth.basic_component.split(',')
          componentAuth.high_component = this.componentDetail.component_auth.high_component.split(',')
        }
        arr.map((item) => {
          item.funcList.map((fun) => {
            delete fun.field
            delete fun.isDrag
            delete fun.icon
            fun.name = fun.label
            fun.id = fun.type
            fun.type = item.type
            fun.choice = componentAuth[item.type].includes(fun.id) ? '1' : '0'
          })
        })
        this.featureData = {data: arr, type: 1}
        console.log(this.featureData)
      })
    },
    // 关闭详情弹框
    closeDialog () {
      this.$bus.emit('closeAddDetailModal', true)
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.componentDetail.id})
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (command) {
      if (command === '1') {
        this.dialogStatus = true
      } else if (command === '2') {
        this.dialogDelete = true
      }
    },
    /** 删除增购 */
    delComponentManage () {
      var jsondata = {'id': this.componentDetail.id}
      HTTPServer.delComponentManage(jsondata, 'Loading').then((res) => {
        this.dialogDelete = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.$bus.emit('closeAddDetailModal', true)
        this.$bus.emit('query-component-list', true, true)
      })
    },
    editComponent () {
      this.dialogAdd = true
    },
    componentStatus () {
      console.log(this.componentDetail)
      var jsondata = {'id': this.componentDetail.id, 'cm_state': this.componentDetail.cm_state === '1' ? '0' : '1'}
      HTTPServer.updateComponentManage(jsondata, 'Loading').then((res) => {
        this.dialogStatus = false
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.getComponentManageDetail()
        this.$bus.emit('query-component-list', true, true)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/component-detail.vue